import { configurePersist } from 'zustand-persist'

const { persist, purge } = configurePersist({
  storage: localStorage,
  rootKey: 'clara'
})

export default persist
export { purge }
